import React from "react";
import PropTypes from "prop-types";
import { Switch, Route, Redirect,withRouter } from "react-router-dom";
// creates a beautiful scrollbar
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import { withStyles } from "@material-ui/core";

import { Header, Footer, Sidebar } from "../../components";

import dashboardRoutes from "../../routes/dashboard.jsx";

import {compose} from "redux"

import {firestoreConnect, isLoaded} from 'react-redux-firebase'

import appStyle from "../../assets/jss/material-dashboard-react/appStyle.jsx";

import image from "../../assets/img/sidebar-2.jpg";
import logo from "../../assets/img/reactlogo.png";

import {UserIsAuthenticated} from "../../utils/AuthRouter"

import _ from "lodash"

import { withFirebase,withFirestore} from 'react-redux-firebase'

import { connect } from 'react-redux'
import { actionTypes } from 'redux-firestore'
let firestoreArray=[];

const switchRoutes = (
    <Switch>
      {dashboardRoutes.map((prop, key) => {
        if (prop.redirect)
          return <Redirect from={prop.path} to={prop.to} key={key} />;
        return <Route path={prop.path} component={UserIsAuthenticated(prop.component)} key={key} />;
      })}
    </Switch>
)

class DashboardLayout extends React.Component {
  state = {
    mobileOpen: false
  };
  handleDrawerToggle = () => {
    this.setState({ mobileOpen: !this.state.mobileOpen });
  };
  getRoute() {
    return this.props.location.pathname !== "/maps";
  }

  logout=()=>{
    const {firebase,history,clearFirestoreState} =this.props
    firebase.logout().then(()=>{
        clearFirestoreState();
    });
  }

  selectOrganisation=(organisationID)=>{
      const {firebase} = this.props
      firebase.updateProfile({
          selectedOrganisation:organisationID
      })

  }




  componentDidMount() {
    if(navigator.platform.indexOf('Win') > -1){
      // eslint-disable-next-line
      const ps = new PerfectScrollbar(this.refs.mainPanel);
    }
  }
  componentDidUpdate() {
    this.refs.mainPanel.scrollTop = 0;
  }

  getUserOrganisations(){
    const {organisations , auth} = this.props;

    let userOrganisations = [];
      if(organisations){
        userOrganisations = organisations.filter( (organisation) => {
            if(organisation.members && organisation.members[auth.uid]){
              return organisation
            }
        });
     }

    return userOrganisations;
    
  }

  render() {
    const {classes, ...rest } = this.props;

    

    return (
      <div style={{backgroundColor:"white",height:"200vh"}} className={classes.wrapper}>
        <Sidebar
          routes={dashboardRoutes}
          logoText={"iSpani"}
          logo={logo}
          image={image}
          handleDrawerToggle={this.handleDrawerToggle}
          open={this.state.mobileOpen}
          color="blue"
          {...rest}
        />
        <div className={classes.mainPanel} ref="mainPanel">
          <Header
            routes={dashboardRoutes}
            handleDrawerToggle={this.handleDrawerToggle}
            logout={this.logout}
            selectOrganisationCallback={this.selectOrganisation}
            userOrganisations={this.getUserOrganisations()}

            {...rest}
          />
          {/* On the /maps route we want the map to be on full screen - this is not possible if the content and conatiner classes are present because they have some paddings which would make the map smaller */}
          {this.getRoute() ? (
            <div className={classes.content}>
              <div className={classes.container}>{switchRoutes}</div>
            </div>
          ) : (
            <div className={classes.map}>{switchRoutes}</div>
          )}
          {/*this.getRoute() ? <Footer /> : null*/}
        </div>
      </div>
    );
  }
}

DashboardLayout.propTypes = {
  classes: PropTypes.object.isRequired
};


export default compose(

    withRouter,
    withStyles(appStyle),
    connect(({ firebase: { auth , profile} }, props) => ({ auth , profile })),

    firestoreConnect((props) =>{ 
      return([
      {
          collection: 'organisations',
          storeAs: "organisations",
      },
      ])
   }),
    connect(
        (state)=>{
            return{
                organisations:state.firestore.ordered.organisations,
            }
        },
        (dispatch)=>{

            return{
                clearFirestoreState: ()=> dispatch({ type: actionTypes.CLEAR_DATA })
            }
        }
    ),

)(DashboardLayout)






// WEBPACK FOOTER //
// ./src/layouts/Dashboard/DashboardLayout.jsx